import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaPhoneAlt,
  FaEnvelope,
  FaCommentDots,
} from "react-icons/fa";

import "../assets/css/Form.css"

function Form() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess("");
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleInputField = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const formSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setErrors({});

    const formdta = {
      property_name: document.title,
      page_url: window.location.href,
      ...formData,
    };

    try {
      const response = await fetch(
        "https://backend.apartmentsingurugram.com/api/lead",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formdta),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        setErrors(result.errors || {});
        return;
      }

      setSuccess(result.message);

      setFormData({
        name: "",
        mobile: "",
        email: "",
        message: "",
      });
    } catch {
      setErrors({
        general: "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className="enquiryForm" onSubmit={formSubmit}>
        <div className="headingArea">
          <h3>Book Site Visit</h3>
          <p>Fill the form & our expert will contact you shortly.</p>
        </div>

        <div className="inputBox">
          <FaUser />
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputField}
          />
        </div>
        {errors.name && <span className="inputError">{errors.name}</span>}

        <div className="inputBox">
          <FaPhoneAlt />
          <input
            type="text"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleInputField}
          />
        </div>
        {errors.mobile && <span className="inputError">{errors.mobile}</span>}

        <div className="inputBox">
          <FaEnvelope />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleInputField}
          />
        </div>
        {errors.email && <span className="inputError">{errors.email}</span>}

        <div className="inputBox textareaBox">
          <FaCommentDots />
          <textarea
            name="message"
            placeholder="Write Your Requirement..."
            maxLength={300}
            value={formData.message}
            onChange={handleInputField}
          />
        </div>

        <div className="countText">
          {formData.message.length}/300 Characters
        </div>

        {errors.message && (
          <span className="inputError">{errors.message}</span>
        )}

        {errors.general && (
          <span className="inputError">{errors.general}</span>
        )}

        <button disabled={loading} className="submitBtn">
          {loading ? (
            <>
              <span className="loader"></span>
            </>
          ) : (
            "Submit Enquiry"
          )}
        </button>

        <p className="privacyText">
          🔒 Your information is 100% secure and will never be shared.
        </p>
      </form>

      {success && (
        <div className="popupOverlay">
          <div className="popupCard">
            <div className="checkIcon">✓</div>
            <h3>Thank You!</h3>
            <p>{success}</p>

            <button onClick={() => setSuccess("")}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Form;